module.exports = __webpack_public_path__ + "static/media/Logo_en.84480541.svg";